export default __webpack_public_path__ + "static/media/editable_point.c490f533.png";